export const css = {
    root: '_1EMoXNWN',
    tabTitle: 'yZeuMIyQ',
    title: 'AZfaUZ2L',
    titleClosed: '_2GTmtHjt',
    titleOpen: '_1WIdc-OY',
    bookIcon: '_1M6Dm9VZ',
    lockIcon: '_1hciLiDk',
    ' _key': 'ascm-theme/ascm/explore-view/content-order'
};
export default css;
